import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const TestComponent = () => {
  return (
    <>
      <Helmet>
        <title>Test | SLP</title>
      </Helmet>
      <Outlet />
    </>
  );
};

export default TestComponent;
